const scrollToTop = () => {
    window.scroll(0, 0);
}

export default scrollToTop;


// WEBPACK FOOTER //
// ./src/components/public/functions/scrollToTop.js